module.exports = __webpack_public_path__ + "img/insIcon.28c29a59.png";